<div class="tab-group">
  <app-tab-header
    [tabs]="tabs"
    [activeIndex]="activeTabIndex()"
    (tabSelected)="setActiveTab($event)"
    [style]="style"
  ></app-tab-header>

  <div class="tab-content {{ style }}">
    <ng-content></ng-content>
  </div>
</div>
